import axios from 'axios'

const apiBaseUrl = process.env.NEXT_PUBLIC_VROOM_API_BASE_URL

const getVrooms = (slugs, locale) => {
  return axios.get(`${apiBaseUrl}/vrooms?slugs=${encodeURI(slugs.join(','))}&locale=${locale}`)
}

const registerSignalVineUser = async formData => {
  try {
    await axios({
      method: 'post',
      url: `${apiBaseUrl}/signal-vine/register`,
      headers: {
        authtoken: process.env.NEXT_PUBLIC_SIGNALVINE_API_AUTH_TOKEN,
      },
      data: formData,
    })

    return { ok: true }
  } catch (error) {
    return { ok: false, error }
  }
}

export default {
  getVrooms,
  registerSignalVineUser,
}
